import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalBody } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faEnvelope, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { ResponseSuccessModal, ResponseFailModal } from './modal/Response';
import Spin from './Spin';
import * as api from '../api';

export const SMSSend = ({
  isOpen,
  isResend,
  toggle,
  smsSendItem,
  reload,
}) => {
  const { t } = useTranslation();
  const [ isLoading, setIsLoading ] = useState(false);
  const [ isOpenSMSSendSuccessModal, setIsOpenSMSSendSuccessModal ] = useState(false);
  const [ isOpenSMSSendFailModal, setIsOpenSMSSendFailModal ] = useState(false);
  const [ messageSMSSendFail, setMessageSMSSendFail ] = useState('');

  const typeFormatter = (type) => {
    const formatter = {
      mobilekey: t('data_column.exchangekey'),
      pincode: t('data_column.pincode'),
    };
    return formatter[type];
  };

  const staffkeyMessageFormatter = (exchangekey) => {
    return `■ ${t('data_column.exchangekey')}\n[${exchangekey}]\n■ ${t('description.app_link')}\nhttps://ovalmms.page.link/key`;
  };

  const sendSMS = async () => {
    try {
      setIsLoading(true);
      if (smsSendItem.type === 'pincode') await api.notifyPincode({ bookingId: smsSendItem.bookingId, pincodeId: smsSendItem.keyId });
      else if (smsSendItem.type === 'mobilekey') await api.notifyMobilekey({ bookingId: smsSendItem.bookingId, userId: smsSendItem.keyId });
      else {
        const message = staffkeyMessageFormatter(smsSendItem.value);
        await api.sendSMS({phoneNumber: smsSendItem.phoneNumber, message});
      }
      toggle();
      setIsOpenSMSSendSuccessModal(true);
      setTimeout(() => {
        setIsOpenSMSSendSuccessModal(false);
        reload();
      }, 1500);
    } catch (error) {
      toggle();
      if (!error.response) setMessageSMSSendFail(error.message);
      else setMessageSMSSendFail(`${error.response.data.code}, ${error.response.data.message}`);
      setIsOpenSMSSendFailModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  const close = () => {
    toggle();
    reload();
  };

  return (
    <Fragment>
      <Modal
        show={isOpen}
        onHide={() => toggle()}
        centered
        size='sm'
      >
        <Spin isSpin={isLoading} isModal={true}/>
        <ModalBody className='text-center m-3'>
          {!isResend ? (
            <Fragment>
              <p className='mb-4 mt-0' style={{fontSize:'18px', color:'#28a745'}}>
                {t('success_message.issue_key')}
              </p>
              <FontAwesomeIcon icon={faCheckCircle} style={{marginBottom:'1.5rem', fontSize:'5em', color:'#28a745'}}/>
            </Fragment>
          ) : ''}
          <p className='mb-0 mt-0' style={{fontSize:'16px'}}>
            {t('confirm_message.send_sms')}
          </p>
          <p className='mb-0 mt-4' style={{fontSize:'16px'}}>
            {typeFormatter(smsSendItem.type)}:
            <span style={{fontWeight:'bold', color:'rgb(59, 125, 221)'}}> {smsSendItem.value}</span>
          </p>
          <button className='modal-btn-cancel' onClick={() => close()}>
            <FontAwesomeIcon icon={faTimesCircle} style={{paddingRight:'3px'}}/>{t('button.cancel')}
          </button>
          <button className='modal-btn-confirm' onClick={() => sendSMS()}>
            <FontAwesomeIcon icon={faEnvelope} style={{paddingRight:'3px'}}/>{t('button.ok')}
          </button>
        </ModalBody>
      </Modal>
      <ResponseSuccessModal
        isOpen={isOpenSMSSendSuccessModal}
        toggle={() => setIsOpenSMSSendSuccessModal(!isOpenSMSSendSuccessModal)}
        message={t('success_message.send_sms')}
      />
      <ResponseFailModal
        isOpen={isOpenSMSSendFailModal}
        toggle={() => setIsOpenSMSSendFailModal(!isOpenSMSSendFailModal)}
        message={messageSMSSendFail || t('error_message.send_sms')}
      />
    </Fragment>
  );
}
